var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('router-view'),_c('Loading',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]}),_c('Dialog',{attrs:{"value":_vm.alert.visible,"options":_vm.alert.options},on:{"input":_vm.alertHide}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }